<template>
	<div class="handOverTask">
		<el-dialog title="交接班" top="0px" append-to-body :visible.sync="dialogVisible" width="400px" :before-close="handleClose">
			<div>
				<el-row class="serveStage">
					<el-col :span="8" class="serveDiv">
						选择服务台
					</el-col>
					<el-col :span="16">
						<el-select size="mini" v-model="value1" @change="serveStageChange" collapse-tags style="width: 100%;" placeholder="请选择">
							<el-option v-for="item in serveStage" :key="item.index" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-col>
				</el-row>
				<el-row class="serveClass">
					<el-col :span="8" class="serveDiv">
						选择班次
					</el-col>
					<el-col :span="16">
						<el-select size="mini" v-model="value2" multiple @change="serveClassChange" style="width: 100%;" placeholder="请选择">
							<el-option v-for="item in serveClass" :key="item.index" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-col>
				</el-row>
				<el-row class="serveTableStage">
					<el-col :span="8" class="serveDiv">
						选择报表服务台
					</el-col>
					<el-col :span="16">
						<el-select filterable size="mini" v-model="value3" multiple @change="statementServeChange" style="width: 100%;" placeholder="请选择">
							<el-option v-for="item in statementServe" :key="item.index" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-col>
				</el-row>
				<createSonTask ref="createControl" :nameTask="nameTask" :listFile="listFile" :contact="serveStageObj" @subSon="subSon"></createSonTask>
				<!--<el-dialog width="1000px" title="内层 Dialog" :visible.sync="dialogVisible2" :before-close="handleClose2" append-to-body>
					<span>{{ accessory }}</span>

					<span slot="footer" class="dialog-footer">
					    <el-button size="mini" @click='dialogVisible2 = false'>确定</el-button>
					</span>
				</el-dialog>-->
			</div>
			<span slot="footer" class="dialog-footer">
			    <el-button size="mini" @click="selectTable">生成任务</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import { GetAllManageServerCenterByUserId, GetAllBanci, GetAllServerCenterManageList, GetAllTaskPerDayByServerCenterId } from "@/api/modules/basicData/task";
	import {
		getToken
	} from "../../../util/auth";
	import createSonTask from "./createSonTask.vue";
	const cookieUser = getToken();
	export default {
		name: "handOverTask",
		data() {
			return {
				dialogVisible: false, //弹窗
				dialogVisible2: false, //第二个弹窗
				createTimeFormat: function(time) { //格式化时间
					return time ? time.replace("T", " ").substr(0, 19) : ''
				},
				serveStage: [],
				serveClass: [],
				statementServe: [],
				serveStageObj: null,
				serveClassObj: [],
				statementServeObj: [],
				value1: '',
				value2: [],
				value3: [],
				beginTime: [],
				endTime: [],
				statementServeVal: [],
				accessory:'交接班.xls',//带入的附件名称
				className:[],
				nameTask:'',
				listFile:{},
			}
		},
		methods: {
			subSon(str){
				this.dialogVisible = false;
				this.value1 = "";
				this.value2 = [];
				this.value3 = [];
				console.log(str.name)
			},
			tabDiv(index){
				return "tabDiv" +index
			},

			handleClose(done) {
				this.dialogVisible = false;
				this.serveStage = [];
			},
			handleClose2(done) {
				this.dialogVisible2 = false;
			},
			selectTable() {

				var str = this.statementServeVal.join(",");
				var time1 = this.timeFormat(this.beginTime[0]);
				var time2 = ''
				this.endTime.forEach((c) => {
					time2 = this.timeFormat(c)
				})
				var obj = {};
				var sheetArr = [];
				this.statementServeObj.forEach((c) => {
					sheetArr.push(c.label)
				});
				GetAllTaskPerDayByServerCenterId(str, time1, time2).then(res => {
					this.tablesToExcel(res, sheetArr, this.accessory, "Excel");
				})
			},
			tablesToExcel(tables, wsnames, wbname, appname) {
				if(this.serveStageObj == null) {
					this.$message({
          				message: '请选择服务台',
          				type: 'warning'
        			});
				} else if(this.serveClassObj.length == 0) {
					this.$message({
          				message: '请选择班次',
          				type: 'warning'
        			});
				} else if(this.statementServeObj.length == 0) {
					this.$message({
          				message: '请选择报表服务台',
          				type: 'warning'
        			});
				} else {
					this.$refs.createControl.dialogVisible = true;
					setTimeout(() => {
						this.$refs.createControl.getTaskName();
					},1000)

//					return false
					var uri = 'data:application/vnd.ms-excel;base64,',
						tmplWorkbookXML =
						'<?xml version="1.0"?><?mso-application progid="Excel.Sheet"?><Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet" xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet">' +
						'<DocumentProperties xmlns="urn:schemas-microsoft-com:office:office"><Author>Axel Richter</Author><Created>{created}</Created></DocumentProperties>' +
						'<Styles>' +
						'<Style ss:ID="Currency"><NumberFormat ss:Format="Currency"></NumberFormat></Style>' +
						'<Style ss:ID="Date"><NumberFormat ss:Format="Medium Date"></NumberFormat></Style>' +
						'</Styles>' +
						'{worksheets}</Workbook>',
						tmplWorksheetXML = '<Worksheet ss:Name="{nameWS}"><Table>{rows}</Table></Worksheet>',
						tmplCellXML = '<Cell{attributeStyleID}{attributeFormula}><Data ss:Type="{nameType}">{data}</Data></Cell>',
						base64 = function(s) {
							return window.btoa(unescape(encodeURIComponent(s)))
						},
						format = function(s, c) {
							return s.replace(/{(\w+)}/g, function(m, p) {
								return c[p];
							})
						}

					var ctx = "";
					var workbookXML = "";
					var worksheetsXML = "";
					var rowsXML = "";
					var tablesArr = [];
					var tablesLength = 0;
					for(let key in tables){
						tablesLength++;
						tablesArr.push(tables[key])
					}
					var headRow = []; // 表头的数据放这里。防止下面的取不到。
					for (var i=0;i<tablesArr.length;i++) {
						if(tablesArr[i].length > 0){
							var HeadRowData = tablesArr[i][0]; //取出有数据的那个表的第一行数据
							for(let key in HeadRowData){
								headRow.push(key)
							}
							break; // 添加完成就停止。
						}
					}
					//console.log("headRow", headRow) // 这就是表头数据了
					for(var i = 0;i < tablesLength; i++) { // 表的个数
						try{
							var rowList = []; // 行数。
							//console.log("headRow---"+i+"---",headRow)
							if(headRow.length > 0){ // 防止表头数据都没。
								rowList.push(headRow); // 不管里面有没有数据 都要添加表头。
							}
							if(tablesArr[i].length > 0){
								var baseData = tablesArr[i];
								for (var q = 0; q < baseData.length; q++) {
									var dataArr = []; // 数据层面
									for (let key in baseData[q]){
										dataArr.push(baseData[q][key])
									}
									rowList.push(dataArr);
								}
							}
							//console.log("rowList",rowList)
							for(var j = 0; j < rowList.length; j++) { // 表的行数  数据+表头的行数
								rowsXML += '<Row>';
								for(var k = 0; k < rowList[j].length; k++) { // 表头的名字 或者是 表里的数据的值
									var dataValue = rowList[j][k];
									ctx = {
										attributeStyleID: '',
										nameType: 'String',
										data: dataValue == null ? "无" : dataValue,
										attributeFormula: ''
									};
									rowsXML += format(tmplCellXML, ctx);
								}
								rowsXML += '</Row>'
							}
							ctx = {
								rows: rowsXML,
								nameWS: wsnames[i] || 'Sheet' + (i + 1)
							};
							//console.log(ctx, "ctx")
							worksheetsXML += format(tmplWorksheetXML, ctx);
							rowsXML = "";
						}catch(e){
							console.error(e)
						}
					}
					ctx = {
						created: (new Date()).getTime(),
						worksheets: worksheetsXML
					};
					workbookXML = format(tmplWorkbookXML, ctx);

					//       查看后台的打印输出
					var base64 = uri + base64(workbookXML);
					this.listFile = this.dataURLtoFile(base64,wbname)
//					console.log(this.listFile,"this.listFile")
//					var link = document.createElement("A");
//					link.href = uri + base64(workbookXML);
//					console.info("base64:---",uri + base64(workbookXML)) // 应该是这个
//					link.download = wbname || 'Workbook.xls';
//					link.target = '_blank';
//					document.body.appendChild(link);
//					link.click();
//					document.body.removeChild(link);
				}


			},
			dataURLtoFile(dataurl, filename) {//将base64转换为文件
				var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
				bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
				while(n--){
					u8arr[n] = bstr.charCodeAt(n);
				}
				return new File([u8arr], filename, {type:mime});
			},
			connect() {
				// GetAllManageServerCenterByUserId(cookieUser.userId).then(res => {
         let ManageServerCenter = JSON.parse(localStorage.getItem('ManageServerCenter'))
					ManageServerCenter.forEach((c) => {
						this.serveStage.push({
							value: c.ID,
							label: c.NAME,
							time: this.createTimeFormat(c.CREATETIME)
						})
					})
				// });
			},
			serveStageChange(val) { //选择服务台
				console.log(val,"val")
				console.log(this.serveStage,"serveStage");
//				return false
				this.serveClass = [];
				this.statementServe = [];
				this.serveStageObj = this.serveStage.find((item) => { //获取选中服务台的数据
					return item.value === val;
				});

				GetAllBanci(val).then(res => {
					res.forEach((c) => {
						c.id = this.guid();
						this.serveClass.push({
							value: c.id,
							label: c.BanciName,
							beginTime: c.BeginTime,
							endTime: c.EndTime
						})
					})
				});
				GetAllServerCenterManageList(val).then(res => {
					console.log(res,"报表服务台")
					if(res.length == 0){
						this.serveStage.forEach((c) => {
							if(c.value == val){
								this.statementServe.push({
									value: c.value,
									label: c.label,
								})
							}
						})
					} else {
						res.forEach((c) => {
							this.statementServe.push({
								value: c.ID,
								label: c.NAME,
							})
						})
					}

				})
			},
			serveClassChange(val) { // 选择班次
				var arr = [];
				for(var i = 0; i < this.serveClass.length; i++) {
					for(var j = 0; j < val.length; j++) {
						if(this.serveClass[i].value == val[j]) {
							arr.push(this.serveClass[i])
						}
					}
				}
				this.serveClassObj = arr;
				var classNameArr = []
				this.serveClassObj.forEach((c) => {
					classNameArr.push(c.label)
				})
				this.className = classNameArr.join(",")
				var beginTimeArr = [];
				var endTimeArr = [];
				//转换成时间戳
				this.serveClassObj.forEach((c) => {
					var date = new Date(this.createTimeFormat(c.beginTime));
					var date2 = new Date(this.createTimeFormat(c.endTime));
					beginTimeArr.push(date.getTime());
					endTimeArr.push(date2.getTime());
				})
				//比较数值大小
				this.beginTime = beginTimeArr.sort(function(a, b) {
					if(a > b) {
						return 1;
					} else if(a < b) {
						return -1
					} else {
						return 0;
					}
				});
				this.endTime = endTimeArr.sort(function(a, b) {
					if(a > b) {
						return 1;
					} else if(a < b) {
						return -1
					} else {
						return 0;
					}
				});
				this.nameTask = this.serveStageObj.time + "," + this.className
			},
			statementServeChange(val) { // 选择报表服务台
				this.statementServeVal = val;
				var arr = [];
				for(var i = 0; i < this.statementServe.length; i++) {
					for(var j = 0; j < val.length; j++) {
						if(this.statementServe[i].value == val[j]) {
							arr.push(this.statementServe[i])
						}
					}
				}
				this.statementServeObj = arr;
			},
			//生成唯一的guid
			S4() {
				return(((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
			},
			guid() {
				return(this.S4() + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + this.S4() + this.S4());
			},

			add0(m) {
				return m < 10 ? '0' + m : m
			},
			timeFormat(timestamp) {
				//timestamp是整数，否则要parseInt转换,不会出现少个0的情况
				var time = new Date(timestamp);
				var year = time.getFullYear();
				var month = time.getMonth() + 1;
				var date = time.getDate();
				var hours = time.getHours();
				var minutes = time.getMinutes();
				var seconds = time.getSeconds();
				return year + '-' + this.add0(month) + '-' + this.add0(date) + ' ' + this.add0(hours) + ':' + this.add0(minutes) + ':' + this.add0(seconds);
			}

		},
		components: {
			createSonTask
		}
	}
</script>

<style scoped>
	.serveDiv {
		height: 28px;
		line-height: 28px;
	}

	.serveClass {
		margin: 15px 0;
	}

	.handOverTask .el-button--mini,
	.handOverTask .el-button--mini.is-round {
		padding: 7px 11px;
	}

	.transfer .el-transfer-panel {
		width: 280px;
	}
	/*.el-dialog__footer{
		text-align: left;
	}*/
</style>
